import { cva } from '@/styled-system/css';

export const accordionHeaderRecipe = cva({
  base: {
    'position': 'relative',
    'cursor': 'pointer',
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'Accordion.Header.gap.leading',
    'paddingBlock': 'Accordion.Header.padding.vert',
    'paddingInline': 'Accordion.Header.padding.horz',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, box-shadow 200ms ease',
    },
    'focusOutline': true,
    'borderTopLeftRadius': 'Accordion.default',
    'borderTopRightRadius': 'Accordion.default',

    '& [data-c11n-component="Heading"]': {
      color: { base: 'Accordion.Header.label.default' },
    },

    '& > [data-c11n-component="Icon"]': {
      color: { base: 'Accordion.Header.icon.leading' },
      width: 'Accordion.Header.icon.width',
      height: 'Accordion.Header.icon.height',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        _hover: {
          '& [data-c11n-component="Heading"]': {
            textDecoration: 'underline',
          },
        },
        _active: {
          '& [data-c11n-component="Heading"]': {
            textDecoration: 'underline',
          },
        },
      },
    },
    expanded: {
      true: {
        backgroundColor: { base: 'Accordion.Header.bg.selected' },
      },
      false: {
        borderBottomLeftRadius: 'Accordion.default',
        borderBottomRightRadius: 'Accordion.default',
        backgroundColor: { base: 'Accordion.Header.bg.default' },
      },
    },
  },
  compoundVariants: [
    {
      expanded: false,
      disabled: false,

      css: {
        backgroundColor: {
          _hover: 'Accordion.Header.bg.hover',
          _active: 'Accordion.Header.bg.pressed',
        },
      },
    },
    {
      expanded: true,
      disabled: false,

      css: {
        backgroundColor: {
          _hover: 'Accordion.Header.bg.selectedHover',
          _active: 'Accordion.Header.bg.selectedPressed',
        },
      },
    },
  ],
});
